import React, { useContext } from 'react';
import { SelectedWebsiteContext } from '../../trackedWebsites/ContextWrapper';
import { Layout } from 'antd';
import TrackedWebsites from '../../trackedWebsites/TrackedWebsites';
import BrokenLinksTabs from '../BrokenLinksTabs';

const { Content } = Layout;

export default function BrokenLinksPage() {
    const { selectedWebsite } = useContext(SelectedWebsiteContext);

    return (
        <Content className="general-layout-content">
            <TrackedWebsites
                tabContent={<BrokenLinksTabs selectedWebsite={selectedWebsite!} />}
                destroyInactiveTabs={true}
                showDomains={true}
            />
        </Content>
    );
}
